import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validaters.format.zip',[Validator])
    .factory('zip', function(BCValidator) {
        function zip(value, instance, field) {
            if (value === undefined || value === '' || value === null) return true;
            return /(^\d{5}$)|(^\d{5}-{0,1}\d{4}$)/.test(value);
        }

        zip.message = function() {
            return 'is not a valid zip code.';
        };


        return new BCValidator(zip,'zip');
    }).name;
